import classNames from 'classnames';
import React from 'react';

type DiscountBadgeProps = {
    className?: string;
    discountRate?: number;
};

export const DiscountBadge = ({
    className,
    discountRate
}: DiscountBadgeProps) => {
    return (
        <span
            style={{ height: 'min-content' }}
            className={classNames('badge badge-danger', className)}
            data-item-card-discount-rate="">
            -{discountRate}%
        </span>
    );
};
